import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { CourseService } from "@scaffold/services/course.service";
import { ItemsService } from "@scaffold/services/items.service";
import { PreviewFrameService } from "@scaffold/tools/preview-frame/preview-frame.service";
import { UserService } from "@services/user.service";

@Component({
  selector: "app-file-display",
  templateUrl: "./file-display.component.html",
  styleUrls: ["../../rendered.component.scss", "../filebrowser.component.scss"],
})
export class FileDisplayComponent implements OnInit {
  @Input() item;
  @Input() tiles;
  @Input() isDisabled;
  @Output() settings: EventEmitter<any> = new EventEmitter();
  @Output() move: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() zip: EventEmitter<any> = new EventEmitter();
  public hasMountedImage
  hasError: boolean;
  constructor(
    private itemsService:ItemsService,
    private previewFrameService: PreviewFrameService,
    private userService: UserService,
    private cd:ChangeDetectorRef
  ) {}
  download_url;
  ngOnInit() {
        this.itemsService.registerItem(this.item).subscribe((d)=>{
      if(d){
        this.item.data = {...this.item.data,...d}
        this.cd.markForCheck()
      }
    })
  }

  openFile(e: Event, file, title) {
    e.preventDefault();
    e.stopPropagation();

    // this.download_url = "/files/" + file;
    this.userService.isLoggedIn().subscribe((loggedIn) => {
      if (loggedIn) {
        this.previewFrameService.openPreview(file,this.item,'' ,title,true);
      }
    });
    //var win = window.open(url, '_blank');
    /*setTimeout(i => {
      this.download_url = undefined;
    },2000)*/
  }

  zipFolder(e: Event, item) {
    e.stopPropagation();
    e.preventDefault();
    this.zip.emit(item);
  }
  getType(title) {
    if (!title) {
      return "File";
    }
    if (title.match(/\.(jp.*g|png|gif|bmp|jfif)$/gi)) {
      return "image";
    } else if (title.match(/\.(docx*|rtf)$/gi)) {
      return "doc";
    } else if (title.match(/\.(pdf)$/gi)) {
      return "pdf";
    } else if (title.match(/\.(zip|7z|rar)$/gi)) {
      return "zip";
    } else {
      return "File";
    }
  }

  openSettings(e: Event, item: any) {
    e.preventDefault();
    e.stopPropagation();
    this.settings.emit(item);
  }

  openMove(e: Event, item: any) {
    e.preventDefault();
    e.stopPropagation();
    this.move.emit(item);
  }

  toDelete(e: Event, item: any) {
    e.preventDefault();
    e.stopPropagation();
    this.delete.emit(item);
  }
}
